import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Typography } from '@mui/material'
import MentorHeader from '../MentorHeader'
import { useState } from 'react'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { red } from '@mui/material/colors'

export default function MentorCommunicationPreference() {
  const communicationPref = {
    email: {
      enabled: true,
      uid: 'abc@gmail.com',
      schedule: {
        title: 'Interview Schedule',
        defaultSchedule: false,
        eventIds: [
          'EVT-54f6041c31a64469a9d92c3705b525ff',
          'EVT-73f56b6134824ad7a0d5fcdaa2d7bf68',
          'EVT-82c92c7fb0744a7ca63f7f0bd47195d9',
        ],
        weeklyHourMap: {
          monday: {
            available: true,
            title: 'Monday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '19:00:00',
              },
            ],
          },
          tuesday: {
            available: true,
            title: 'Tuesday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '20:00:00',
              },
            ],
          },
          wednesday: {
            available: true,
            title: 'Wednesday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '17:00:00',
              },
            ],
          },
          thursday: {
            available: true,
            title: 'Thursday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '20:00:00',
              },
            ],
          },
          friday: {
            available: true,
            title: 'Friday',
            slotList: [
              {
                startTime: '11:15:00',
                endTime: '18:00:00',
              },
            ],
          },
          saturday: {
            available: false,
            title: 'Saturday',
          },
          sunday: {
            available: false,
            title: 'Sunday',
          },
        },
        timeZone: '%2B05%3A30',
      },
    },
    whatsapp: {
      enabled: true,
      uid: '1234567890',
      schedule: {
        title: 'Interview Schedule',
        defaultSchedule: false,
        eventIds: [
          'EVT-54f6041c31a64469a9d92c3705b525ff',
          'EVT-73f56b6134824ad7a0d5fcdaa2d7bf68',
          'EVT-82c92c7fb0744a7ca63f7f0bd47195d9',
        ],
        weeklyHourMap: {
          monday: {
            available: true,
            title: 'Monday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '19:00:00',
              },
            ],
          },
          tuesday: {
            available: true,
            title: 'Tuesday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '20:00:00',
              },
            ],
          },
          wednesday: {
            available: true,
            title: 'Wednesday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '17:00:00',
              },
            ],
          },
          thursday: {
            available: true,
            title: 'Thursday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '20:00:00',
              },
            ],
          },
          friday: {
            available: true,
            title: 'Friday',
            slotList: [
              {
                startTime: '11:15:00',
                endTime: '18:00:00',
              },
            ],
          },
          saturday: {
            available: false,
            title: 'Saturday',
          },
          sunday: {
            available: false,
            title: 'Sunday',
          },
        },
        timeZone: '%2B05%3A30',
      },
    },
    sms: { enabled: false },
    voiceCall: {
      enabled: true,
      uid: '1234567890',
      schedule: {
        title: 'Interview Schedule',
        defaultSchedule: false,
        eventIds: [
          'EVT-54f6041c31a64469a9d92c3705b525ff',
          'EVT-73f56b6134824ad7a0d5fcdaa2d7bf68',
          'EVT-82c92c7fb0744a7ca63f7f0bd47195d9',
        ],
        weeklyHourMap: {
          monday: {
            available: true,
            title: 'Monday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '19:00:00',
              },
            ],
          },
          tuesday: {
            available: true,
            title: 'Tuesday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '20:00:00',
              },
            ],
          },
          wednesday: {
            available: true,
            title: 'Wednesday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '17:00:00',
              },
            ],
          },
          thursday: {
            available: true,
            title: 'Thursday',
            slotList: [
              {
                startTime: '10:30:00',
                endTime: '20:00:00',
              },
            ],
          },
          friday: {
            available: true,
            title: 'Friday',
            slotList: [
              {
                startTime: '11:15:00',
                endTime: '18:00:00',
              },
            ],
          },
          saturday: {
            available: false,
            title: 'Saturday',
          },
          sunday: {
            available: false,
            title: 'Sunday',
          },
        },
        timeZone: '%2B05%3A30',
      },
    },
    inAppChat: { enabled: false },
    pushNotification: { enabled: false },
  }
  const [expanded, setExpanded] = useState(false)
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <>
      <MentorHeader greetingsEnabled={true} />
      <div className="m-4">
        <h3>Communication and Preference </h3>
        <div>
          <Accordion
            className="rounded"
            expanded={expanded === 'emailPanel'}
            onChange={handleChange('emailPanel')}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <div className="d-flex justify-content-between w-100">
                <Typography className="w-30">{'Email Notification'}</Typography>
                <Chip
                  className="mx-4 px-2"
                  label="Enabled"
                  color="success"
                  sx={{ width: '100px' }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget
                maximus est, id dignissim quam.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className="rounded"
            expanded={expanded === 'whatsappPanel'}
            onChange={handleChange('whatsappPanel')}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <div className="d-flex justify-content-between w-100">
                <Typography className="w-30">{'Whatsapp Notification'}</Typography>
                <Chip
                  className="mx-4 px-2"
                  label="Disabled"
                  color="error"
                  sx={{ width: '100px' }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget
                maximus est, id dignissim quam.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className="rounded"
            expanded={expanded === 'smsPanel'}
            onChange={handleChange('smsPanel')}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <div className="d-flex justify-content-between w-100">
                <Typography className="w-30">{'SMS Notification'}</Typography>
                <Chip
                  className="mx-4 px-2"
                  label="Disabled"
                  color="error"
                  sx={{ width: '100px' }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Lorem facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget
                maximus est, id dignissim quam.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className="rounded"
            expanded={expanded === 'voiceCallPanel'}
            onChange={handleChange('voiceCallPanel')}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <div className="d-flex justify-content-between w-100">
                <Typography className="w-30">{'Voice Call'}</Typography>
                <Chip
                  className="mx-4 px-2"
                  label="Enabled"
                  color="success"
                  sx={{ width: '100px' }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget
                maximus est, id dignissim quam.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </>
  )
}
